import {isLoggedIn} from '../session'
import {globalActions} from '../../state/global-actions'
import {crypto} from '../crypto'

export const unauthorizedResponseInterceptor = async error => {
    if (error.response?.status === 401 && isLoggedIn()) {
        await crypto.clearPrivateKeys().catch(() => {})
        globalActions.setSessionUser(null)
        window.location.assign('/auth')
    }
    return Promise.reject(error)
}
